//main
import ContentFormatXC from "../content/webc/content-format-xc";

import WebbDividerSmall from "../content/webb/webb-divider-sm";
import HeaderSectionDark from "../content/webb/head-section-dark";

import ContactsListModule from "../content/contacts/contacts-list";

import { UserForm } from "../services/srvc-utilities";

export default function Contacts() {

  return (
  <>
    <ContentFormatXC 
      head='Contacts'
      link={`/${UserForm()}/home`}
      form= 'small'
      data= {
        <>
          <WebbDividerSmall />
          <ContactsListModule />

        </>
      } 
    />
  </>
  )
}